import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// components
import { Scrollbar as ScrollbarOrigin } from 'components/UI'
// utils
import { darken } from 'polished'

export const OptionWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`

export const SelectsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex: 1;

  > div {
    flex: 1;
  }
`

export const InputWrapper = styled.div`
  flex: 0.7;

  > div {
    width: 100%;
  }
`

export const ColorWrapper = styled.div<{ color?: string }>`
  background: ${({ color }) => color || colors.gray240};
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 6px;
  margin-top: 6px;
  font-weight: 500;
  color: ${colors.white};
  height: 44px;
  cursor: pointer;
  min-width: 82px;
`

export const ColorPickerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: start;
`

export const Scrollbar = styled(ScrollbarOrigin)`
  height: 300px;
  padding-right: 16px;
  margin-top: 20px;
`

export const AddButton = styled('div')`
  && {
    color: ${colors.blue500};
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    margin-top: 8px;
    user-select: none;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`
